// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/app-" + (chunkId === 5597 ? "Auth" : chunkId) + "." + {"278":"b92ba8c4","3023":"38da101a","5597":"413ca3a6","6877":"6f322792"}[chunkId] + ".chunk.css";
};